import api from '.'

export const anchors = {
  list (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/anchors`, null, success, fail)
  },
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/anchors`, data, success, fail)
  },
  update (anchorId, data, success, fail) {
    api.authenticatedRequest('PUT', `/anchors/${anchorId}`, data, success, fail)
  },
  delete (anchorId, success, fail) {
    api.authenticatedRequest('DELETE', `/anchors/${anchorId}`, null, success, fail)
  },
  setParticipantAnchor (trialId, participantId, anchorId, datetime, success, fail) {
    api.authenticatedRequest('PUT', `/trials/${trialId}/participants/${participantId}/anchors/${anchorId}`, { datetime }, success, fail)
  },
  clearParticipantAnchor (trialId, participantId, anchorId, success, fail) {
    api.authenticatedRequest('DELETE', `/trials/${trialId}/participants/${participantId}/anchors/${anchorId}`, null, success, fail)
  }
}
